import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { ProductsMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { useManageTags } from './useManageTags'

export const ManageTagsButton = memo(() => {
  const { openManageTags } = useManageTags()

  return (
    <Fragment>
      <Button
        data-testid="contractors-list-manage-tags-btn"
        className={tw`mr-2`}
        color="white"
        size="small"
        leftIcon={<ProductsMinor width={20} />}
        onClick={openManageTags}
      >
        Manage tags
      </Button>
    </Fragment>
  )
})
